import { render, staticRenderFns } from "./DataImportBox.vue?vue&type=template&id=7616d110&scoped=true"
import script from "./DataImportBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataImportBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataImportBox.vue?vue&type=style&index=0&id=7616d110&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7616d110",
  null
  
)

export default component.exports